ike-avatar {
  div.avatar {
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 35px;
    justify-content: center;
    outline: none;
    width: 35px;
  }

  a {
    height: 23px;
  }
}
